import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Input, message } from 'antd';
import { Translate, useTranslate } from '@above-the-treeline/localization';
import { useUserPreferences } from '../../../UserPreferences';

const { TextArea } = Input;

const EditRoleDescription = () => {
	const { translate } = useTranslate();
	const userPreferences = useUserPreferences();
	const { requestRole } = userPreferences.getReviewCopyDownloadPreferences();

	const [roleDescription, setRoleDescription] = useState(requestRole);

	const saveRoleDescription = async () => {
		const didSucceed = await userPreferences.saveRoleDescription(
			roleDescription,
		);
		if (didSucceed) {
			return message.success(translate('role_description_saved'));
		}
		message.error(translate('error_saving_role_description'));
	};

	const onTextAreaInputChange = e => {
		setRoleDescription(e.target.value);
	};

	const getTextAreaSubText = () => {
		return <Translate id="role_desc_note" />;
	};

	return (
		<div className="edit-role-description">
			<div className="prompt-and-save-icon-row">
				<div className="role-description-prompt">
					<span className="description-of-your-role-label">
						<Translate id="description_of_role" />
					</span>
					: (<Translate id="common_across_requests" />)
				</div>
				<div
					title={translate('save_role_description')}
					className="icon-save-icon plus"
					onClick={saveRoleDescription}
				/>
			</div>
			<TextArea
				rows={4}
				value={roleDescription}
				onChange={onTextAreaInputChange}
			/>
			<div className="text-area-subtext">{getTextAreaSubText()}</div>
		</div>
	);
};

export default EditRoleDescription;
